var idProofFactory = function ($resource, $window) {
  var retrieveIDProofQueriesApi =
    "/participant-web-services/rest/partialauth/idProof/retrieveIDProofingData";

  var submitIDProofAnswersApi =
    "/participant-web-services/rest/partialauth/idProof/submitIDProofData";

  var requestPinApi =
    "/participant-web-services/rest/partialauth/requestPin/:optOut";

  var optOutModalAndReqPinApi =
    "/participant-web-services/rest/partialauth/optOutModalRequestPin/:optOut";

  var optOutQueryAndReqPinApi =
    "/participant-web-services/rest/partialauth/optOutQueryRequestPin/:optOut";

  var optOutErrorAndReqPinApi =
    "/participant-web-services/rest/partialauth/optOutErrorRequestPin/:optOut";

  var optExpiredReqPinApi =
    "/participant-web-services/rest/partialauth/otpExpiredRequestPin/:optOut";

  var optInConsentApi =
    "/participant-web-services/rest/partialauth/idProof/optInConsent/IDPROF_CON";

  return {
    retrieveIDProofQueries: $resource(
      __baseApiUrl__ + retrieveIDProofQueriesApi,
      {},
      {
        query: {
          method: "GET",
          isArray: false
        },
      }
    ),

    submitIDProofAnswers: $resource(
      __baseApiUrl__ + submitIDProofAnswersApi,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    requestPin: $resource(
      __baseApiUrl__ + requestPinApi,
      { optOut: "@optOut" },
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    optOutModalAndReqPin: $resource(
      __baseApiUrl__ + optOutModalAndReqPinApi,
      { optOut: "@optOut" },
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    optOutWithExpiredOTPAndReqPin: $resource(
      __baseApiUrl__ + optExpiredReqPinApi,
      { optOut: "@optOut" },
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    optOutErrorAndReqPin: $resource(
      __baseApiUrl__ + optOutErrorAndReqPinApi,
      { optOut: "@optOut" },
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    optOutQueryAndReqPin: $resource(
      __baseApiUrl__ + optOutQueryAndReqPinApi,
      { optOut: "@optOut" },
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    optInConsent: $resource(
      __baseApiUrl__ + optInConsentApi,
      {},
      {
        query: {
          method: "GET",
          isArray: false
        },
      }
    ),
  };
};

idProofFactory.$inject = ["$resource", "$window"];
export default idProofFactory;
